import './App.css';
import Boards from './Components/Boards';
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Boards/>
      </header>
    </div>
  );
}

export default App;
